export default __webpack_public_path__ + "static/media/building_gray.def99a83.svg";